export default __webpack_public_path__ + "static/media/eb-ultra-blk-poster-3.660693b2.jpg";